import { Flex, Text } from "@radix-ui/themes";
import { cn } from "@/lib/utils";

export type DarkFeatureCardProps = {
  icon: React.ReactNode;
  iconColor: string;
  title: string;
  description: string;
  className?: string;
};

export default function DarkFeatureCard({
  icon,
  iconColor,
  title,
  description,
  className,
}: DarkFeatureCardProps) {
  return (
    <Flex
      direction="column"
      className={cn(
        "h-[280px] w-full min-w-0 gap-3 rounded-lg bg-blue-900 p-8 shadow-[0px_14px_20px_-1px_rgba(5,12,43,0.14)]",
        className,
      )}
    >
      <span className={cn("w-7 h-7 flex-shrink-0", iconColor)}>{icon}</span>
      <Text className="font-figtree font-bold text-[18px] md:text-[24px] lg:text-[32px] text-white leading-[1.15] tracking-[-0.18px] md:tracking-[-0.24px] lg:tracking-[-0.32px]">
        {title}
      </Text>
      <Text className="font-open-sans text-[14px] lg:text-md text-white/85 leading-relaxed">
        {description}
      </Text>
    </Flex>
  );
}
